export default __webpack_public_path__ + "static/Oxblood-e142b003488f31a3a0ff742ce9305a93.jpg";